import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';

interface RefreshStaleResponse {
  ok: boolean;
  refreshed: string[];
  workflow_id: string | null;
}

/**
 * useRefreshStale — POSTs to `/v1/briefs/:id/refresh-stale`. Starts a
 * Temporal workflow that re-plans/drafts stale sections. Invalidates the
 * brief query; `useBrief` keeps polling while `stale_sections` remain.
 */
export function useRefreshStale(briefId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiPost<RefreshStaleResponse>(`/v1/briefs/${briefId}/refresh-stale`, {}),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['brief', briefId] });
      void qc.invalidateQueries({ queryKey: ['briefs'] });
    },
  });
}
